import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { AsyncPipe, NgClass, NgIf, NgTemplateOutlet } from '@angular/common';
import { Campaign } from '@app/core/models/common.models';
import { ItemLabelComponent } from '@app/shared/components/campaign-adgroup-label/item-label.component';
import { SharedDirectivesModule } from '@app/shared/shared-directives.module';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';

@Component({
  selector: 'adspt-performance-group-label',
  templateUrl: './item-label.component.html',
  styleUrls: ['./item-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, NgIf, AsyncPipe, TranslateModule, SharedDirectivesModule, NgTemplateOutlet],
})
export class PerformanceGroupLabelComponent extends ItemLabelComponent<
  Pick<Campaign, 'performanceGroupName' | 'performanceGroupOptimizationType'>
> {
  @Input()
  labelProperty = 'performanceGroupName' as const;

  disableTypeTranslate = true;

  get type(): string {
    return (
      this.ts.instant(`global-filter.sub-filters.${this.item.performanceGroupOptimizationType}`) +
      ' ' +
      this.ts.instant('global-filter.group-selector.pg')
    );
  }

  constructor(
    private ts: TranslateService,
    store: Store,
  ) {
    super(store);
  }
}
